<template>
  <div @click="$refs.fileinput.click()">
    <input
      ref="fileinput"
      type="file"
      :accept="accept"
      class="d-none"
      @change="uploadFile($event)"
    />
    <slot name="button" v-bind:progress="progress">
      <b-button
        v-if="typeButton !== 'small'"
        variant="primary"
        class="btn"
        :disabled="progress.enabled"
      >
        {{ text }}
      </b-button>
    </slot>
    <slot name="progress" v-bind:progress="progress">
      <vs-progress
        v-if="progress.enabled"
        :percent="progress.percent"
        :indeterminate="progress.indeterminate"
        :color="color"
      />
    </slot>
  </div>
</template>
<script>

import { uuid } from 'vue-uuid';
import { BButton } from 'bootstrap-vue';

import {
  ioGetPrivateUploadUrl,
  ioUploadFileToPrivateUrl
} from '@/febos/servicios/api/herramientas.api';

export default {
  data: () => ({
    progress: {
      enabled: false,
      percent: 0,
      indeterminate: true
    }
  }),
  methods: {
    async uploadFile(event) {
      const file = event.target.files[0];
      if (file.size > this.maxSizeInMb * 1048576) {
        this.$emit('input', {
          failed: true,
          failedMessage: `El archivo ${file.name} supera el máximo de tamaño permitido por archivo (${this.maxSizeInMb} MB)`
        });

        return false;
      }
      const fileId = uuid.v1();
      const baseUrl = this.uploadTo;
      const identifier = this.identifier ? `-${this.identifier}` : '';
      const url = `${baseUrl}${Date.now()}${fileId}${identifier}.${file.name.split('.').pop()}`;
      try {
        this.progress.enabled = true;
        this.progress.indeterminate = true;

        const response = await ioGetPrivateUploadUrl(url, file.type);

        this.progress.indeterminate = false;
        await ioUploadFileToPrivateUrl(
          response.data?.url,
          file,
          (percent) => {
            this.progress.percent = percent;
          }
        );

        this.$emit('input', {
          id: fileId,
          name: file.name,
          mime: file.type,
          date: this.$moment().format('YYYY-MM-DD HH:MM:SS'),
          path: url,
          failed: false
        });
      } catch (e) {
        console.error(e);
        this.$emit('input', {
          failed: true,
          failedMessage: e.message
        });
      } finally {
        this.progress.enabled = false;
        this.progress.percent = 0;
        this.progress.indeterminate = false;
      }
      return true;
    }
  },
  props: {

    text: {
      type: String
    },
    accept: {
      type: String
    },
    value: {
      type: Object
    },
    uploadTo: {
      type: String,
      required: true
    },
    maxSizeInMb: {
      type: Number,
      default: 20
    },
    identifier: {
      type: String
    },
    containerClass: {
      type: [String, Object]
    },
    typeButton: {
      type: String
    }
  },
  components: {
    BButton
  }
};

</script>
